import { AxiosInstance } from 'axios'

import { logWarning } from '@marketplace-web/observability/logging-util'

import { LOCALE_HEADER_KEY } from '../constants'

export const isoLocaleInterceptor = (instance: AxiosInstance) =>
  instance.interceptors.request.use(config => {
    const locale = document.querySelector('meta[name="iso-locale"]')?.getAttribute('content')

    if (locale) {
      config.headers.set(LOCALE_HEADER_KEY, locale)
    } else {
      logWarning('Unable to retrieve iso locale for API call')
    }

    return config
  })
